<div class="drawer-basket">
  <div class="drawer-basket__header">
    <h2 class="drawer-basket__title">Din kurv</h2>
    <button matIconButton class="drawer-basket__close" (click)="site.closeRightDrawer()" aria-label="Luk kurv">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <app-basket [compact]="true" />
</div>
